import Popup from "../../../../../../common/components/popup";
import ReconciliationRequestsItems from "./reconciliation-request-items";

export const ReconciliationRequestItemsPopup = ({ 
  selectedReconciliationRequest,
  closeModal,
  
}: any) => {

    return (
      <>
        <Popup onClose={closeModal}>
          <ReconciliationRequestsItems
            selectedReconciliationRequest={selectedReconciliationRequest}
          />
        </Popup>
      </>
    )
  }